import React from 'react';
import { Market } from '../../../types';
import { useNavigate } from 'react-router-dom';

interface AdminUserCreatedMarketsSectionProps {
  markets: Market[];
}

export function AdminUserCreatedMarketsSection({ markets }: AdminUserCreatedMarketsSectionProps) {
  const navigate = useNavigate();

  if (!markets.length) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-6 text-center text-gray-500">
        This user has not created any markets yet.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {markets.map((market) => (
        <button
          key={market.id}
          onClick={() => navigate(`/admin/market/${market.id}`)}
          className="text-left bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow p-5"
        >
          <div className="flex items-start justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900 line-clamp-2">{market.title}</h3>
            <StatusPill status={market.status} />
          </div>
          <p className="text-sm text-gray-500 line-clamp-3 mb-4">{market.description || 'No description provided.'}</p>
          <dl className="grid grid-cols-2 gap-3 text-xs text-gray-600">
            <div>
              <dt className="font-semibold text-gray-500 uppercase">Category</dt>
              <dd>{market.category}</dd>
            </div>
            <div>
              <dt className="font-semibold text-gray-500 uppercase">Created</dt>
              <dd>{market.created_at ? new Date(market.created_at).toLocaleDateString() : '—'}</dd>
            </div>
            <div>
              <dt className="font-semibold text-gray-500 uppercase">Total Bets</dt>
              <dd>{market.total_bets}</dd>
            </div>
            <div>
              <dt className="font-semibold text-gray-500 uppercase">Is Private</dt>
              <dd>{market.is_private ? 'Yes' : 'No'}</dd>
            </div>
          </dl>
        </button>
      ))}
    </div>
  );
}

interface StatusPillProps {
  status: Market['status'];
}

function StatusPill({ status }: StatusPillProps) {
  const classes = getStatusClasses(status);
  const label = status.charAt(0).toUpperCase() + status.slice(1);
  return <span className={`text-xs font-semibold px-3 py-1.5 rounded-full ${classes}`}>{label}</span>;
}

function getStatusClasses(status: Market['status']) {
  switch (status) {
    case 'active':
      return 'bg-green-100 text-green-700';
    case 'resolved':
      return 'bg-blue-100 text-blue-700';
    case 'ended':
    case 'expired':
      return 'bg-yellow-100 text-yellow-700';
    case 'cancelled':
      return 'bg-red-100 text-red-700';
    default:
      return 'bg-gray-100 text-gray-600';
  }
}

